import { render } from "./VsRatio.vue?vue&type=template&id=77980c3c"
import script from "./VsRatio.vue?vue&type=script&lang=js"
export * from "./VsRatio.vue?vue&type=script&lang=js"

import "./VsRatio.vue?vue&type=style&index=0&id=77980c3c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__